import type { FilingsQuery } from '@thinkalpha/quant-ws-client/client.js';
import type { Filing } from '@thinkalpha/quant-ws-client/contracts/filings.js';
import { quantWsClient } from 'src/lib/newQuant';
import { container } from 'src/StaticContainer';

export const log = container.get('Logger').getSubLogger({ name: 'FilingsApi' });

export type GetFilingsQuery = Omit<FilingsQuery, 'symbols'> & { symbols: string[] };

export async function getFilings({
    symbols,
    types = [],
    tags,
    start,
    end,
    cursorTimestamp,
    cursorId,
    direction = 'older',
    limit,
    sortBy = 'submittedAt',
}: GetFilingsQuery): Promise<Filing[]> {
    if (symbols.length === 0) {
        return [];
    }

    return quantWsClient.getFilings({
        symbols,
        types,
        tags,
        start,
        end,
        cursorTimestamp,
        cursorId,
        direction,
        limit,
        sortBy,
    });
}

export async function getFilingTypes(): Promise<string[]> {
    try {
        return await quantWsClient.getFilingTypes();
    } catch (e) {
        log.error('Failed to fetch filing types', { error: e });
        throw e;
    }
}

export async function getFilingTags(): Promise<string[]> {
    try {
        return await quantWsClient.getFilingTags();
    } catch (e) {
        log.error('Failed to fetch filing tags', { error: e });
        throw e;
    }
}

export async function getFilingSummary(filingId: string): Promise<string> {
    try {
        return (await quantWsClient.getFilingSummary(filingId)).response;
    } catch (e) {
        log.error('Failed to fetch filing summary', { error: e, filingId });
        throw e;
    }
}
